// extracted by mini-css-extract-plugin
export default {"mainHeadinstyle":"brand-module_mainHeadinstyle__ZpQTF","privacyWrapper":"brand-module_privacyWrapper__u0GRB","privacysubHeading":"brand-module_privacysubHeading__7Hpht"};